<template>
  <v-card flat>
    <v-card-text>
      <v-textarea
        v-model="comment"
        label="Comment"
        outlined
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'Voyage',

    data: () => ({
    }),
    computed: {
      comment: {
        get() {
          return this.$store.state.input.comment;
        },
        set(value) {
          this.$store.commit("setComment", value);
        }
      }
    },
    methods: {
      save: function() {
        localStorage.setItem("ces-state", JSON.stringify(this.$store.state.input));
      }
    }
  }
</script>
